var React = require('react');
var labels = require('MemberJoinLabels');
var { sanitize } = require('isomorphic-dompurify');
var { $simpleSelect, $input } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var selectableDataFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableDataFunctions.jsx');
var validationFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationFunctions.jsx');
var memberTypeChecker = require('../../../../../Scripts/React/MemberTypeChecker.jsx').step2;
var MemberAppFuncs = require('../../MembershipApplication/ReactDependencies/memberAppFuncs.jsx');

class CreateProfile extends React.Component {
    constructor(props) {
        super(props);

        this.bindFunctions();
    }

    bindFunctions() {
        this.getPrefixDropdownMarkup = this.getPrefixDropdownMarkup.bind(this);
        this.getSuffixDropdownMarkup = this.getSuffixDropdownMarkup.bind(this);
        this.getPrimaryPracticeDropdownLabel = this.getPrimaryPracticeDropdownLabel.bind(this);
        this.getPrimaryPracticeDropdownMarkup = this.getPrimaryPracticeDropdownMarkup.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handlePrimaryPracticeChange = this.handlePrimaryPracticeChange.bind(this);
        //this.dismissUserExistsModal = this.dismissUserExistsModal.bind(this);

        this.handleInputOnBlurEvent = this.handleInputOnBlurEvent.bind(this);
        this.handleInputOnBlurEventDropDown = this.handleInputOnBlurEventDropDown.bind(this);
    }

    componentDidMount() {
        if (this.props.appState.isMilitary) {
            this.props.updateStepState('primaryPracticeLocation', 'USSA');
        }

        if (this.props.appState.isInternational && !this.props.stepState.primaryPracticeLocation) {
            this.props.updateStepState('primaryPracticeLocation', 'INTL');
        }

        this.props.updateComponentMarkup('prefixDropdown', this.getPrefixDropdownMarkup());
        this.props.updateComponentMarkup('suffixDropdown', this.getSuffixDropdownMarkup());
    }

    getPrefixDropdownMarkup() {
        return <$simpleSelect
            value={this.props.stepState.prefix}
            selectdatafunction={selectableDataFunctions.getPrefixDropdownOptions}
            removemilitary={this.props.appState.isMilitary ? "" : "true"}
            name="prefix"
            onChange={this.handleInputOnBlurEventDropDown} />;
    }

    getSuffixDropdownMarkup() {
        return <$simpleSelect
            value={this.props.stepState.suffix}
            selectdatafunction={selectableDataFunctions.getSuffixDropdownOptions}
            name="suffix"
            onChange={this.handleInputOnBlurEventDropDown} />;
    }

    // displayed label changes depending on app type
    getPrimaryPracticeDropdownLabel() {
        var appType = this.props.appState.appType;
        if (memberTypeChecker.activePhysician(appType)) {
            return labels.step2.primaryPractice.primaryPractice;
        }

        if (memberTypeChecker.resident(appType)) {
            return labels.step2.primaryPractice.residencyProgram;
        }

        if (memberTypeChecker.medical(appType)) {
            return labels.step2.primaryPractice.trainingProgram;
        }

        if (memberTypeChecker.trainer(appType)) {
            return labels.step2.primaryPractice.trainingProgram;
        }

        if (memberTypeChecker.careTeamProvider(appType)) {
            return labels.step2.primaryPractice.currentlyPracticing;
        }
    }

    getPrimaryPracticeDropdownMarkup() {
        return !this.props.appState.isInternational ? <$simpleSelect
            value={this.props.stepState.primaryPracticeLocation}
            selectdatafunction={selectableDataFunctions.getApiSelectableOptions}
            valueprop="StateCode"
            labelprop="StateDescription"
            name="primaryPracticeLocation"
            selectoptions="statesByCountry"
            disabled={this.props.appState.isMilitary}
            onChange={this.handlePrimaryPracticeChange}
            validations={[validationFunctions.required]}        /> : null;
    }

    getDistrictDropdownMarkup() {
        var primaryPracticeLocationUC = this.props.stepState.primaryPracticeLocation ? this.props.stepState.primaryPracticeLocation.toUpperCase() : '';
        var primaryPracticeLocationLC = this.props.stepState.primaryPracticeLocation ? this.props.stepState.primaryPracticeLocation.toLowerCase() : '';
        var availableDistricts = MemberAppFuncs.districtCount(primaryPracticeLocationUC);

        if (memberTypeChecker.hideDistrict(this.props.appState.appType) || primaryPracticeLocationUC == null || availableDistricts == 0) {
            return null;
        }

        var modalFunc = function () {
            return this.props.showInfoModal('primaryDistrictLocation');
        }.bind(this);

        var modalInfoFunc = function () {
            return this.props.showInfoModal(primaryPracticeLocationLC + "districtinfo");
        }.bind(this);

        var label = this.props.hasModalInfo('primaryDistrictLocation') ? <span onClick={modalFunc}><span className={"get-info"}>{this.props.getInfoModalContent("primaryDistrictLocation").infoIconLabel}</span></span> : null;
        var info = this.props.hasModalInfo(primaryPracticeLocationLC + "districtinfo") ? <span onClick={modalInfoFunc}><span className={"get-info"}>{this.props.getInfoModalContent(primaryPracticeLocationLC + "districtinfo").infoIconLabel}</span></span> : null;

        return <div>
            <label>{labels.step4.districtOfPrimaryPractice} {label} {info}</label>
            <$simpleSelect
                value={this.props.stepState.primaryDistrictLocation}
                ppl={primaryPracticeLocationUC}
                selectoptions="districtsByState"
                name="primaryDistrictLocation"
                selectdatafunction={selectableDataFunctions.getApiDistricts}
                valueprop="DistrictCode"
                labelprop="DistrictDescription"
                onChange={this.handleInputChange}
                validations={[validationFunctions.required]} /><br />
        </div>;
    }
    
    handleInputChange(event) {
        this.props.updateStepState(event.target.name, sanitize(event.target.value));
    }

    handlePrimaryPracticeChange(event) {
        this.props.updateStepState(event.target.name, sanitize(event.target.value));
        this.props.updateStepState("primaryDistrictLocation", null);
    }

    componentDidUpdate(oldProps) {
        if (oldProps.stepState.prefix !== this.props.stepState.prefix) {
            this.props.updateComponentMarkup('prefixDropdown', this.getPrefixDropdownMarkup());
        }
        if (oldProps.stepState.suffix !== this.props.stepState.suffix) {
            this.props.updateComponentMarkup('suffixDropdown', this.getSuffixDropdownMarkup());
        }
    }

    getUserExistsModal() {
        const customersMaskInfoData = this.props.customersMaskInfo.map(function (record, index) {
            return <div key={index} className="modal-body">
                <button type="button" className={"cta"} onClick={() => this.props.showLoginMessage(index)}>{labels.userExists.thisIsMe}</button> <span id={"loginMessage" + index} className={"login-message"}><a href={labels.step2.loginUrl}>{labels.userExists.loginMessage}</a></span><br />
                <span>{record.FirstName} {record.LastName}</span><br />
                <span>{record.MaskedEmail}</span><br />
                <span>{record.MaskedPhone}</span>
            </div>;
        }.bind(this));

        return <div className={"basemodal modal fade"} id="userExistsModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className={"modal-dialog modal-dialog-centered"} role="document">
                <div className={"modal-content"}>
                    <div className={"modal-header"}>
                        <a href="#" className={"close"} onClick={this.showMemberServicesModal} data-dismiss="modal" aria-label="Close">
                            <img src="../../../../../Images/base/dist/icon-close.svg" alt="" />
                        </a>
                    </div>
                    <div className={"modal-body"}>
                        <h3>{labels.userExists.haveWeMet}</h3>
                        <p>{labels.userExists.accountsWeThinkAreYou}</p>
                        {customersMaskInfoData}
                    </div>
                    <div className={"modal-footer"}>
                        <a href="#" className={"cta cancel"} onClick={this.showMemberServicesModal} data-dismiss="modal">{labels.userExists.help}</a>
                        <a href="#" className={"cta cancel"} onClick={this.props.dismissUserExistsModal} data-dismiss="modal">{labels.userExists.noneAreMe}</a>
                    </div>
                </div>
            </div>
        </div>;
    }

    getMemberServicesModal() {
        return <div className={"basemodal modal fade"} id="memberServicesModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className={"modal-dialog modal-dialog-centered"} role="document">
                <div className={"modal-content"}>
                    <div className={"modal-header"}>
                        <a href="#" className={"close"} data-dismiss="modal" aria-label="Close">
                            <img src="../../../../../Images/base/dist/icon-close.svg" alt="" />
                        </a>
                    </div>
                    <div className={"modal-body"}>
                        <h3>{labels.memberServices.contactMemberServices}</h3>
                        <p>{labels.memberServices.helpWithMembership}</p>
                        <div className={"modal-body"}>
                            <span>{labels.memberServices.phoneNumber}</span><br />
                            <span>{labels.memberServices.emailAddress}</span><br />
                            <span>{labels.memberServices.hoursOfOperation}</span>
                        </div>
                    </div>
                    <div className={"modal-footer"}>
                    </div>
                </div>
            </div>
        </div>;
    }

    showMemberServicesModal() {
        $('#memberServicesModal').modal('show');
    }

    handleInputOnBlurEvent(event) {
        this.props.checkUserExistingModal();
        this.props.checkIfUserExists(event);
    }

    handleInputOnBlurEventDropDown(event) {
        this.props.checkUserExistingModal();
        this.handleInputChange(event);
    }

    render() {

        const primaryPracticeMarkup = !this.props.appState.isInternational
            ? <div className={"field-wrap"}>
                <label>{this.getPrimaryPracticeDropdownLabel()}</label>
                {this.getPrimaryPracticeDropdownMarkup()}
                {this.getDistrictDropdownMarkup()}
              </div>
            : null;

        const userExistsModal = this.getUserExistsModal();
        const memberServicesModal = this.getMemberServicesModal();
        //const districtInfoMarkup = {this.getDistrictDropdownMarkup();
    

        const formMarkup = <div className={"col-md-6"}>
            <div className={"field-wrap"}>
                <label>{labels.step2.prefix}</label>{this.props.stepState.componentMarkup.prefixDropdown}
            </div>
            <div className={"field-wrap"}>
                <label>{labels.step2.firstName}</label><$input name="firstName" value={this.props.stepState.firstName} onChange={this.handleInputChange} validations={[validationFunctions.required]} onBlur={this.handleInputOnBlurEvent} />
            </div>
            <div className={"field-wrap"}>
                <label>{labels.step2.middleName}</label><$input name="middleName" value={this.props.stepState.middleName} onChange={this.handleInputChange} onBlur={this.props.checkUserExistingModal} />
            </div>
            <div className={"field-wrap"}>
                <label>{labels.step2.lastName}</label><$input name="lastName" value={this.props.stepState.lastName} onChange={this.handleInputChange} validations={[validationFunctions.required]} onBlur={this.handleInputOnBlurEvent} />
            </div>
            <div className={"field-wrap"}>
                <label>{labels.step2.suffix}</label>{this.props.stepState.componentMarkup.suffixDropdown}
            </div>
            {primaryPracticeMarkup}
        </div>;


        return <div className={"create-profile-container"}>
            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{labels.step2.createProfile}</h3>
                    </div>
                    <div className={"edit"}>
                        {formMarkup}
                    </div>
                </div>
            </div>
            {userExistsModal}
            {memberServicesModal}
        </div>;
    }
}

module.exports = CreateProfile;